import removeHostFromUrl from '@devhacker/shared/utils/removeHostFromUrl';
import { HOME_URL } from '~/constants/config';

export const isHomeLink = (link: string): boolean => {
  const isInternalLink = ['/wp-content/', '/special/', '/feed', '/promokod', '.pdf'].every(
    (item) => !link?.includes(item),
  );

  const result = (link?.indexOf(HOME_URL) === 0 || link?.indexOf('/') === 0) && isInternalLink;

  return result;
};

const hostsToClean = [
  'burninghut.ru',
  'dev.burninghut.ru',
  'stage.burninghut.ru',
  'test.burninghut.ru',
];

export function removeBurninghutFromUrl(url: string) {
  try {
    const { hostname } = new URL(url);
    if (hostsToClean.includes(hostname)) return removeHostFromUrl(url);
  } catch {
    /* empty */
  }

  return url;
}
